import request from '@/config/axios'

export interface AmazonResearchConfigVO {
  id?: number
  enabled: boolean
  modelId?: number | null
  defaultSite: string
  enabledSkillCodesJson: string
  title: string
  subtitle: string
  disclaimer: string
}

export interface McpVendorCredentialVO {
  id?: number
  vendorCode: string
  displayName: string
  baseUrl: string
  /** 脱敏密钥；保存时空或 ********xxxx 表示不覆盖 */
  secret?: string
  extraHeaders?: string | null
  status: number
}

export const AmazonResearchConfigApi = {
  get: async (): Promise<AmazonResearchConfigVO | null> =>
    request.get({ url: '/ai/amazon-research/config/get' }),
  save: async (data: AmazonResearchConfigVO): Promise<number> =>
    request.put({ url: '/ai/amazon-research/config/save', data })
}

export const McpVendorCredentialApi = {
  list: async (): Promise<McpVendorCredentialVO[]> =>
    request.get({ url: '/ai/mcp-vendor/list' }),
  save: async (data: McpVendorCredentialVO): Promise<boolean> =>
    request.put({ url: '/ai/mcp-vendor/save', data })
}
